import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colorBorder, colorBackground, colorHover } from '@/utils/palette';
import { left } from '@/utils/directions';
import { GiMeal } from 'react-icons/gi';
import CryptoJS from 'crypto-js';
import SidebarLink, { SidebarNavLink, SidebarLinkTitle } from './SidebarLink';
import SidebarCategory from './SidebarCategory';
import { PermissionContext } from '../../../../context/PermissionContext';
import { AuthContext } from '../../../../context/AuthContext';


const SidebarContent = ({
  onClick, changeToLight, changeToDark, collapse,
}) => {
  const { permissionsAccess } = useContext(PermissionContext);
  const { userid, setUserId } = useContext(AuthContext);
  // const [userID, setUserID] = useState();
  const [activeCategory, setActiveCategory] = useState(null);

  const handleToggle = (category) => {
    setActiveCategory(prev => (prev === category ? null : category)); // Toggle the category
  };
  useEffect(() => {
    // Decrypt and retrieve the user ID from localStorage only once when the component mounts
    const encryptedData = localStorage.getItem('userid');
    if (encryptedData) {
      const bytes = CryptoJS.AES.decrypt(encryptedData, 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2');
      const decryptedUserId = bytes.toString(CryptoJS.enc.Utf8);
      setUserId(decryptedUserId);
    }
  }, []); // Empty dependency array ensures this runs only once

  

  return (
    <SidebarContentWrap 
      collapse={collapse}
    >
      <SidebarBlock collapse={collapse}>
    
        
       
        <SidebarLink
          title="App Dashboard"
          icon="smartphone"
          route="/dashboard"
          onClick={onClick}
        />
       
        
      
      </SidebarBlock>
      <SidebarBlock collapse={collapse}>

        {permissionsAccess?.[0]?.master_id === '1'
        && permissionsAccess?.[0]?.view === 1 && (
        <SidebarCategory 
          title="Agent" 
          icon="user" 
          collapse={collapse}
          isOpen={activeCategory === 'agent'}
          onToggle={() => handleToggle('agent')}
        >
          <SidebarLink 
            title="Search" 
            icon="magnifier" 
            color="green" 
            route="/admin/agent"
            onClick={onClick}
            
          />
          <SidebarLink 
            title="Request" 
            color="orange"
            icon="users"
            route="/admin/agentrequest"
            onClick={onClick}
          />
          <SidebarLink 
            title="Rejected Request" 
            color="red"
            icon="warning"
            route="/admin/agentRejectedRequest"
            onClick={onClick}
          />
        </SidebarCategory>
)}
        {permissionsAccess?.[1]?.master_id === '2'
&& permissionsAccess?.[1]?.view === 1 && (
<SidebarCategory
  title="Restaurant" 
  icon="apartment"
  collapse={collapse}
  isOpen={activeCategory === 'restaurant'}
  onToggle={() => handleToggle('restaurant')}
>
  <SidebarLink 
    title="Search" 
    icon="magnifier" 
    color="green" 
    route="/admin/restaurant"
    onClick={onClick}
  />
  <SidebarLink 
    title="Request" 
    color="orange"
    icon="users"
    route="/admin/restaurantrequest"
    onClick={onClick}
  />
  <SidebarLink 
    title="Rejected Request" 
    color="red"
    icon="warning"
    route="/admin/restaurantRejectedRequest"
    onClick={onClick}
  />
</SidebarCategory>
)}


        {permissionsAccess?.[1]?.master_id === '2'
&& permissionsAccess?.[1]?.view === 1 && (
<SidebarCategory
  title="Meal" 
  icon="dinner"
  collapse={collapse}
  isOpen={activeCategory === 'meal'}
  onToggle={() => handleToggle('meal')}
>
  <SidebarLink 
    title="Search" 
    icon="magnifier" 
    color="green" 
    route="/admin/meal"
    onClick={onClick}
  />
  <SidebarLink 
    title="Request" 
    color="orange"
    icon="users"
    route="/admin/mealrequest"
    onClick={onClick}
  />
  <SidebarLink 
    title="Rejected Request" 
    color="red"
    icon="warning"
    route="/admin/mealRejectedRequest"
    onClick={onClick}
  />
</SidebarCategory>
)}

       
        {/* {permissionsAccess?.[0]?.master_id === '1'
        && permissionsAccess?.[0]?.view === 1 && (
          <SidebarLink title="Agent" icon="user" route="/admin/agent" onClick={onClick} />
        )} */}


        {/* {permissionsAccess?.[1]?.master_id === '2'
        && permissionsAccess?.[1]?.view === 1 && (
          <SidebarLink title="Restaurant" icon="apartment" route="/admin/restaurant" onClick={onClick} />
        )} */}


        {/* {permissionsAccess?.[2]?.master_id === '3'
        && permissionsAccess?.[2]?.view === 1 && (
          <SidebarLink title="Meal" icon="dinner" route="/admin/meal" onClick={onClick} />
        )} */}

      
           


        {permissionsAccess?.[3]?.master_id === '4'
        && permissionsAccess?.[3]?.view === 1 && (
          <SidebarLink title="Booking" icon="list" route="/admin/booking" onClick={onClick} />
        )}
        {permissionsAccess?.[6]?.master_id === '7'
        && permissionsAccess?.[6]?.view === 1 && (
        <SidebarLink 
          title="Trip" 
          icon="car"
          route="/admin/trip"
          onClick={onClick}
        />
        )}
        {userid === '1' && (
          <SidebarLink 
            title="Currency" 
            icon="history"
            route="/admin/currency"
            onClick={onClick}
          />
        )}
      
   
        {permissionsAccess?.[8]?.master_id === '9'
        && permissionsAccess?.[8]?.view === 1 && (
        <SidebarLink 
          title="Day Book" 
          icon="car"
          route="/admin/daybook"
          onClick={onClick}
        />
        )}
       

        {permissionsAccess?.[7]?.master_id === '8'
        && permissionsAccess?.[7]?.view === 1 && (

          <SidebarCategory 
            title="Restaurant Account"
            icon="chart-bars"
            collapse={collapse}
            isOpen={activeCategory === 'account'}
            onToggle={() => handleToggle('account')}
          >
           
            <SidebarLink 
              title="Account" 
              color="orange"
              icon="chart-bars" 
              route="/admin/account"
              onClick={onClick}
            />
            <SidebarLink 
              title="Approved" 
              icon="thumbs-up" 
              color="green"
              route="/admin/accountapproved"
              onClick={onClick}
            />
            <SidebarLink 
              title="Pending Approval" 
              icon="clock" 
              color="tomato"
              route="/admin/pendingaccountapproval"
              onClick={onClick}
            />
            <SidebarLink 
              title="Rejected"
              color="red"
              icon="cross" 
              route="/admin/accountrejected"
              onClick={onClick}
            />
            <SidebarLink 
              title="Overall"
              color="purple"
              icon="printer" 
              route="/admin/overallaccount"
              onClick={onClick}
            />
          </SidebarCategory>


        
        // <SidebarLink 
        //   title="Restaurant Account" 
        //   icon="chart-bars"
        //   route="/admin/account"
        //   onClick={onClick}
        // />
      )}


        {permissionsAccess?.[5]?.master_id === '6'
        && permissionsAccess?.[5]?.view === 1 && (
          <SidebarCategory 
            title="Payment Approval"
            icon="checkmark-circle"
            collapse={collapse}
            isOpen={activeCategory === 'payment'}
            onToggle={() => handleToggle('payment')}
          >
            <SidebarLink 
              title="Approved" 
              icon="thumbs-up" 
              color="green" 
              route="/admin/payment/approved" 
              onClick={onClick}
            />
            <SidebarLink 
              title="Pending" 
              color="orange"
              icon="warning"
              route="/admin/payment/pending"
              onClick={onClick}
            />
            <SidebarLink 
              title="Rejected"
              color="red"
              icon="cross"
              route="/admin/payment/reject"
              onClick={onClick}
            />
          </SidebarCategory>
        )}


       
        
       
        
        


        {/* <SidebarLink title="Restaurant" icon="apartment" route="/admin/restaurant" onClick={onClick} />
        <SidebarLink title="Meal" icon="dinner" route="/admin/meal" onClick={onClick} /> */}

        {/* {(userid === '1' || localStorage.getItem(userid) === '1') && (
        <SidebarCategory title="User Manager" icon="user" collapse={collapse}>
          <SidebarLink title="Users" icon="users" route="/usermanager/users" onClick={onClick} />
          <SidebarLink title="Users Management" icon="database" route="/usermanager/management" onClick={onClick} />
        </SidebarCategory>
)} */}
   
        {userid === '1' && (
        <SidebarCategory 
          title="User Manager"
          icon="user"
          collapse={collapse}
          isOpen={activeCategory === 'userManager'}
          onToggle={() => handleToggle('userManager')}
        >
          <SidebarLink title="Users" icon="users" route="/usermanager/users" onClick={onClick} />
          <SidebarLink title="Users Management" icon="database" route="/usermanager/management" onClick={onClick} />
        </SidebarCategory>
      )}
        
        
        
  
        
      </SidebarBlock>
      {userid === '1' && (
        <SidebarLink 
          title={!collapse ? 'Utility' : ''}
          icon="users" 
          route="/admin/utility"
          onClick={onClick}
        />
       )}
      {userid === '1' && (
      <SidebarLink 
        title={!collapse ? 'Whatsapp setting' : ''}
        icon="bubble"
        route="/admin/wpsetting"
        onClick={onClick}
      />
      )}

      <SidebarLink 
        title={!collapse ? 'Logs' : ''}
        icon="book"
        route="/admin/logs"
        onClick={onClick}
      />
      
    </SidebarContentWrap>
  );
};

SidebarContent.propTypes = {
  changeToDark: PropTypes.func.isRequired,
  changeToLight: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  collapse: PropTypes.bool,
};

SidebarContent.defaultProps = {
  collapse: false,
  onClick: () => {},
};

export default SidebarContent;

// region STYLES

const SidebarContentWrap = styled.div`
  height: 100%;
  overflow: auto;
  padding-top: 0;
  
  & > div:last-child {
    width: 4px !important;

    div {
      transition: height 0.3s;
      opacity: 0.52;
    }
  }
  
  @media screen and (min-width: 576px) {
    padding-top: 15px;
    
    ${props => props.collapse && `
      width: 55px;
      overflow: visible !important;
      transition: width 0.3s;
    `}
  }
`;

const SidebarBlock = styled.ul`
  padding: 15px 0;
  border-bottom: 1px solid ${colorBorder};
  list-style-type: none;
  
  &:last-child {
    border: none;
  }
  
  @media screen and (min-width: 576px) {
    
    ${props => props.collapse && `
      & > li > a,
      & > li > button {
        overflow: hidden;
        width: 55px;
        background: ${colorBackground(props)};
        
        span:last-of-type {
          opacity: 0;
          transition: 0.3s;
        }
  
        ${SidebarLinkTitle} {
          position: absolute;
          width: 160px;
          ${left(props)}: 70px;
        }
  
        &:hover {
          background: ${colorHover(props)};
        }
      }
      
      & > li:hover > a,
      & > li:hover > button {
        width: 275px;
        
        span {
          opacity: 1;
        }
      }
    `}
  }
`;

// endregion

